import { Directive, HostListener, Input, OnInit } from '@angular/core';

import { ContextMenuItem } from '../../models/context-menu-item.model';
import { Menu } from '../../models/menu.model';
import { ContextMenuService } from '../../services/context-menu.service';
import { DeviceDetector } from '../../services/device-detector.service';

@Directive({
    selector: '[ohpContextMenuTarget]'
})
export class ContextMenuTargetDirective implements OnInit {
    @Input('ohpContextMenuTarget') public model: Menu<ContextMenuItem>;

    // Provides capability for host component to explicitly disable context menu, e.g. clicking on an icon opens up the same context menu
    // as right clicking on the entire item in MRU list. This will prevent duplicated menus from showing up.
    @Input('ohpContextMenuDisabled') public disabled: boolean;

    public desktop: boolean;

    constructor(
        private readonly contextMenuService: ContextMenuService,
        private readonly deviceDetector: DeviceDetector
    ) {
    }

    public ngOnInit() {
        this.desktop = this.deviceDetector.isDesktopDevice();
    }

    @HostListener('contextmenu', ['$event'])
    public onContextMenu(event: MouseEvent): void {
        if (!this.desktop || !this.model || !event || this.disabled) {
            return;
        }
        event.preventDefault();
        // Allow time for previous menu to be destroyed via currently propagating contextmenu event
        setTimeout(() => {
            this.contextMenuService.showMenu({
                menu: this.model,
                position: {
                    left: event.clientX,
                    top: event.clientY
                }
            });
        }, 0);
    }
}
